module.exports = __webpack_public_path__ + "static/img/rank_280.6373a42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_280.png
// module id = T3sW
// module chunks = 1